import { render, staticRenderFns } from "./SoilTexturesTable.vue?vue&type=template&id=4a655d8d"
import script from "./SoilTexturesTable.vue?vue&type=script&lang=js"
export * from "./SoilTexturesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports